// This is generated.  Alter it in blockGroups/searchElements/types/Range.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const { id, title, propertyName, format } = hNode;
    //This block tells us nothing about namespaces/relations

    const subDataDictionary = {};

    // Create TypeBox string schema with date-time format (JSON Schema 2020-12 standard)
    // https://json-schema.org/draft/2020-12/json-schema-validation#name-dates-times-and-duration
    const dateTimeSchema = Type.String({
      'x-id': id,
      title: title,
      'x-dataType': 'string',
      'x-propertyName': propertyName,
      format: 'date-time', // JSON Schema 2020-12 standard format for ISO 8601
      'x-displayFormat': format, // Custom display format for UI
    });

    const partialTypeDefinition = {
      [propertyName]: dateTimeSchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType('searchElements', 'Range', module.exports);
